import { BaseElement } from './base-element';
import { ElementType } from './element-type';
import { ThemeColors } from './theme-colors';

export class Page extends BaseElement {
  saveToHistory: boolean = true;

  title: string | null = null;
  lead: string | null = null;

  infoTitle: string | null = null;
  infoMessage: string | null = null;
  infoContent: BaseElement[] | null = null;

  tipTitle: string | null = null;
  tipMessage: string | null = null;
  tipContent: BaseElement[] | null = null;
  breadcrumbs: string[] = ['Home'];

  sections: BaseElement[] = [];

  locale: string = 'da';

  maxWidth: string = '1200px';

  externalEmbedding: boolean = false;

  themeOverride: ThemeColors | null = null;

  constructor() {
    super();
    this.elementType = ElementType.page;
  }
}
